import { render, staticRenderFns } from "./CorpStatusSettings.vue?vue&type=template&id=2b92e24a&scoped=true&"
import script from "./CorpStatusSettings.vue?vue&type=script&lang=js&"
export * from "./CorpStatusSettings.vue?vue&type=script&lang=js&"
import style0 from "./CorpStatusSettings.vue?vue&type=style&index=0&id=2b92e24a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92e24a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VTooltip})
